export default class GiveawayTooltips {
  constructor() {
    this.reciptTooltip = document.querySelector('.recipt-number-tooltip');
    this.buyDateTooltip = document.querySelector('.buy-date-tooltip');
    this.modal = document.querySelector('.take-part__modal');
    if (this.modal) {
        this.modalClose = document.querySelector('.close-modal')
        this.buyDateBox = document.querySelector('.buy-date-addon');
        this.reciptBox = document.querySelector('.recipt-addon');
    }
    if(this.reciptTooltip && this.buyDateTooltip && this.modal && this.modalClose && this.buyDateBox && this.reciptBox) {
        this.events();
    }
      
  }

  events() {
    this.reciptTooltip.addEventListener('click', () => {
        this.buyDateBox.classList.add("hidden");
        this.reciptBox.classList.remove("hidden");
        if (!this.modal.classList.contains('opened')) {
            this.modal.classList.add("opened");
        }
    })
    this.buyDateTooltip.addEventListener('click', () => {
        this.reciptBox.classList.add("hidden");
        this.buyDateBox.classList.remove("hidden");
        if (!this.modal.classList.contains('opened')) {
            this.modal.classList.add("opened");
        }
    })
    this.modalClose.addEventListener('click', () => {
        this.modal.classList.remove("opened");
        this.reciptBox.classList.remove("hidden")
        this.buyDateBox.classList.remove("hidden")
    })
  }
}
